module.exports = __webpack_public_path__ + "static/media/yampi3.989171aa.png";